export enum AccessType {
  AppUser = 'App User',
  MessageOnly = 'Message Only',
  AdminAppUser = 'Admin App User'
}

export interface AppUser {
  id: string;
  name: string;
  email: string;
  department: string;
  accessType: AccessType;
  isContact?:  boolean;
  inherited?:  boolean;
  clientId?:   number;
  clientName?: string;
  smsConsent?: number | null;
}

export interface LogEntry {
  id:          number;
  userName:    string;
  description: string;
  dateTime:    string;
}

export interface BuildingContact {
  id: string;
  name: string;
  email: string;
  department: string;
}
